import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PlatformService } from "@core/services/platform.service";
import { Feedback } from "@modules/instructor/models/feedback";
import { TRANSLATION_SCOPE } from "@modules/instructor/i18n/scope";

@Component({
  selector: 'app-my-feedbacks',
  templateUrl: './my-feedbacks.component.html',
  styleUrls: ['./my-feedbacks.component.scss']
})
export class MyFeedbacksComponent implements OnInit {
  @Output()
  public OnBack = new EventEmitter<string>();

  @Input() public feedbacks: Feedback[] = null;

  translationScope = TRANSLATION_SCOPE;
  displayedColumns: string[] = ['index', 'description', 'created'];

  constructor(
    private platform: PlatformService,
  ) { }

  ngOnInit(): void {
  }

  public Back(): void {
    if (this.platform.isBrowser) {
      window.scroll({
        top: 70,
        left: 100,
        behavior: 'smooth',
      });
    }
    this.OnBack.emit('my-courses');
  }

}
